<script>
import Vue from "vue";
import VTooltip from "v-tooltip";

Vue.use(VTooltip);
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrPerfRaporGiris from "@/models/StrPerfRaporGiris";

import "v-tooltip/dist/v-tooltip.css";

export default {
  mixins: [Api, Sabit, StrPerfRaporGiris],
  props: ["BirimId", "DonemId", "Sorgulama", "AltDonemId"],
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      RiskDegerler: [],
      Veriler: [],
      FormData: [],
      AltDonemler: [],
      gostergelistesi: [],
      Eylemler: {},
      donem_yili: "",
      deger: "",
      aciklama: "",
      bugun: null,
    };
  },
  watch: {
    Sorgulama() {
      this.Get();
    },
    TabloId() {
      this.Get();
    }
  },
  methods: {
    Get() {
      this.bugun = new Date();
      this.RiskDegerler = [];

      let Filter = "&Donemid=" + this.DonemId + "&Gerceklesmedonemid=" + this.AltDonemId;

      if (this.BirimId != null && this.BirimId != "") {
        Filter = Filter + "&BirimId=" + this.BirimId;
      }

      console.log(Filter);

      this.ActionsFilterGet({ Service: "StrRaporlama/GetKurumsalRiskRaporu", Page: this.Page, Filter: Filter }).then((res) => {
        this.RiskDegerler = res.Data;
        console.log(this.RiskDegerler);
        this.RiskDegerler.sort(this.buyuktenKucugeSiralama);
      });
    },
    Bol(Data) {
      if (Data != null) {
        let metinDizisi = Data.split("/ ");

        metinDizisi.sort((a, b) => {
          const regex = /^\d+/;

          const numA = a.match(regex) ? parseInt(a.match(regex)[0], 10) : null;
          const numB = b.match(regex) ? parseInt(b.match(regex)[0], 10) : null;

          if (numA !== null && numB !== null) {
            return numA - numB;
          }

          if (numA !== null) return -1;
          if (numB !== null) return 1;

          return a.localeCompare(b, "tr", { sensitivity: "base" });
        });

        return metinDizisi;
      } else {
        return null;
      }
    },
    buyuktenKucugeSiralama(a, b) {
      return b.Donemriskpuanim - a.Donemriskpuanim;
    },
    renk(Data, Kategori) {
      if (Kategori == "10luk Puan") {
        if (Data > 0 && Data <= 25) {
          return "green"; // Düşük risk için sarı
        }
        if (Data > 25 && Data <= 64) {
          return "yellow"; // Orta risk için yeşil
        }
        if (Data > 64) {
          return "red"; // Yüksek risk için kırmızı
        }
      } else {
        if (Data > 19 && Data <= 25) {
          return "#800000"; // 5lik çok yüksek için
        }
        if (Data >= 12 && Data < 20) {
          return "red"; // yüksek 
        }
        if (Data >= 6 && Data < 12) {
          return "orange"; // orta 
        }
        if (Data >= 3 && Data < 6) {
          return "yellow"; // Düşük 
        }
        if (Data > 3) {
          return "green"; // çok düşük
        }
      }
    },


  },
  created() {
    this.Get();
  }
};
</script>

<template>
  <div>
    <div class="text-sm-end">
     <button type="button" class="btn btn-success btn-rounded mb-2 me-2" @click="
        ExcelExport(
        'Eylem Planı',
          'Eylem Planı')
        ">
        <i class="mdi mdi-file-export-outline me-1"></i>
        Excel'e Aktar
      </button>
    </div>

    <div ref="ExcelExportTable" class="table-responsive">
      <div class="table-responsive">
        <table style="width: 100%">
          <tr>
            <td colspan="9" style="text-align: center">
              <div>
                <h4>Risk Eylem Planı</h4>
              </div>
            </td>
          </tr>
        </table>
        <br />

        <table style="border: 1px solid; border-collapse: collapse" border="1" class="table table-md table-bordered border-success mb-0">
          <thead class="table-light" style="text-align: center">
            <tr>
              <th>KURUM / BİRİM</th>
              <td colspan="9"></td>
            </tr>

            <tr style="text-align: center; font-weight: bold">
              <th>Kurum / Birim Hedefi</th>
              <th>Tespit Edilen Risk</th>
              <th>Risk Puanı</th>
              <th>Kontrol Yöntemi</th>
              <th>Yapılacak Eylemler</th>
              <th>Eylemin Başlama Tarihi</th>
              <th>Eylemin Bitiş Tarihi</th>
              <th>Eylemin Sorumlusu</th>
              <th>Tamamlanan Eylemler</th>
              <th>Açıklama</th>
            </tr>
          </thead>
          <tbody v-for="(Data, index) in RiskDegerler" :key="index">
            <tr>
              <td>{{ Data.Birim_hedefi }}</td>
              <td>{{ Data.Tespit_edilen_risk }}</td>
              <td class="text-center" :style="{background: renk(Math.round(Math.round(Data.Etki)*Math.round(Data.Olasilik)), Data.Riskkategori) } "><span style="color: black">{{Math.round(Math.round(Data.Etki)*Math.round(Data.Olasilik), Data.Riskkategori)}}</span></td>
              <td v-if="Data.Kontrolturu == 2">Yönlendirici Kontrol</td>
              <td v-else-if="Data.Kontrolturu == 3">Önleyici Kontrol</td>
              <td v-else-if="Data.Kontrolturu == 4">Düzenleyici Kontrol</td>
              <td v-else-if="Data.Kontrolturu == 5">Saptayıcı Kontrol</td>
              <td v-else ></td>
              <td>
                <ul v-for="(Data2, index) in Bol(Data.riske_verilecek_cevaplar)" :key="index">
                  <li>{{ Data2 }}</li>
                </ul>
              </td>
      
              <td>{{ Data.baslamatarihiriskgiris | formatDateTable }}</td>
              <td>{{ Data.bitistarihiriskgiris | formatDateTable }}</td>
              <td>{{ Data.Riskinsahibi }}</td>
              <td>
                <ul v-for="(Data2, index) in Bol(Data.Riske_verilen_cevaplar)" :key="index" >
                  <li>{{ Data2 }}</li>
                </ul>
              </td>
              <td>{{ Data.Aciklama }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
